import { SellTagModelType } from '@teinor/erp/types/company/order/sell/sellTag'
import { LittleModalCreateEdit } from '../../../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { ModalEditComponentProps } from '../../../../../../../../baseComponents/ModalsLayouts/types'
import { permissionCheck } from '../../../../../../../../baseComponents/PermissionChecker/function'
import { FormRender } from '../../../../../../../../forms/FormRenderer/types'
import { valueOrDefaultValue } from '../../../../../../../../utils/globals/valueOrDefaultValue'
import useCustomerTypesRandomColor from '../../../../../../../../utils/hooks/customer/useCustomerTypesRandomColor'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'
import useSellTagTypesDict from '../../../../../../../../utils/hooks/sells/useSellTagTypesDict'


interface ModalCESellTagProps extends ModalEditComponentProps { 
    readOnly?: boolean
}

const ModalCESellTag: React.FC<ModalCESellTagProps> = ({ userPermissions, allRowData, readOnly, ...rest }) => {
    const { t } = useTwinTranslation()
    const { getDefaultRandomColorCustomerTypes } = useCustomerTypesRandomColor()
    const tagTypesDict = useSellTagTypesDict()

    const fields: FormRender<SellTagModelType> = [
        {
            cols: 1,
            elements: [
                {
                    name: 'name',
                    label: t('name', 'Nombre'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    required: true
                },
                {
                    name: 'color',
                    label: t('color', 'Color'),
                    component: 'InputColorWithMargin',
                    defaultValue: allRowData?.color || getDefaultRandomColorCustomerTypes()
                },
                {
                    name: 'type',
                    label: t('tagType', 'Tipo de etiqueta'),
                    component: 'CustomSelect',
                    items: tagTypesDict,
                    required: true,
                    readOnly
                },
                {
                    name: 'id',
                    component: 'InputHidden'
                },
            ],
        },
    ]
    if (allRowData && allRowData?.id && userPermissions) {
        const parsedFields = valueOrDefaultValue(fields, userPermissions, allRowData)
        return (<LittleModalCreateEdit fields={parsedFields} url={'/api/app/order/sell/sellTag/updateSellTag'} translations={{ title: t('editTag', 'Editar etiqueta'), button: t('save', 'Guardar') }} haveButtonPermissions={permissionCheck(userPermissions, 'update')} {...rest} />)
    }

    const defaultCreateTagsFields = allRowData ? valueOrDefaultValue(fields, userPermissions || { n: 1, permission: 'create' }, allRowData) : fields
    return (<LittleModalCreateEdit fields={defaultCreateTagsFields} url={'/api/app/order/sell/sellTag/createSellTag'} translations={{
        title: t('createTag', 'Crear etiqueta'),
        button: t('create', 'Crear')
    }} haveButtonPermissions={true} {...rest} />)
}

export default ModalCESellTag